import { render, staticRenderFns } from "./goods-card.vue?vue&type=template&id=47bdc8be&scoped=true&lang=pug&"
import script from "./goods-card.vue?vue&type=script&lang=js&"
export * from "./goods-card.vue?vue&type=script&lang=js&"
import style0 from "./goods-card.vue?vue&type=style&index=0&id=47bdc8be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bdc8be",
  null
  
)

export default component.exports